import styled from 'styled-components';
import { TableRows } from 'ui/tableRows';
import { colors, spacing, body2, body2Bold } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledRow = styled(TableRows)`
  display: flex;
  align-items: center;
  padding-left: ${spacing.plusHalf};
  gap: ${spacing.plusHalf};
`;

enum DiffType {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  DELETED = 'DELETED',
}

const getColor = (action: string) => {
  const diffColors: Record<DiffType, string> = {
    [DiffType.ADDED]: colors.positive100,
    [DiffType.CHANGED]: colors.warning100,
    [DiffType.DELETED]: colors.red100,
  };
  return diffColors[action as DiffType] || colors.textPrimary;
};

export const Action = styled.div`
  ${body2Bold};
  width: ${pxToRem(125)};
  color: ${({ changeType }: { changeType: string }) => getColor(changeType.toUpperCase())};
`;

export const Cell = styled.div`
  ${body2};
  min-width: ${pxToRem(125)};
  max-width: fit-content;
  box-sizing: border-box;
  display: table-cell;
  padding: ${spacing.threeQuarter} 0;
  margin: 0;
  overflow: visible;
`;

export const Id = styled.span`
  color: ${colors.grey35};
`;
